import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useRefreshNotificationCount = () => {
    const queryClient = useQueryClient();

    return useCallback(() => {
        queryClient.invalidateQueries({ queryKey: ['notification', 'count'] });
    }, [queryClient]);
};
